import {
  ButtonSecondary,
  ButtonSize,
  Currency,
  formatBalance,
  IconBlock,
  IconSelected,
} from '@ui/src';
import { Balance } from '../../types';

import cn from '../styles.module.css';

interface CurrencyItem extends Currency {
  render?: Record<string, React.JSX.Element>;
}

const formatCurrencies = (
  currencies: CurrencyItem[],
  balances: Balance[],
  setBlockPopupVisible: (data: boolean) => void,
  setSelectedBlockCurrency: (data: Currency) => void,
  setEnablePopupVisible: (data: boolean) => void,
  setSelectedEnableCurrency: (data: Currency) => void,
) => {
  const nextList = currencies?.map((item) => {
    const result = { ...item };

    const currentBalance = balances?.find(
      (balance) => balance.currencyId === item.id,
    );

    const render: Record<string, React.JSX.Element> = {
      name: (
        <div className={!currentBalance ? cn.disabledBalance : ''}>
          {result.name}
        </div>
      ),
      description: (
        <div className={!currentBalance ? cn.disabledBalance : ''}>
          {result.description}
        </div>
      ),
      decimals: (
        <div
          className={`${cn.availableRow} ${
            !currentBalance ? cn.disabledBalance : ''
          }`}
        >
          <div>
            {' '}
            {currentBalance
              ? formatBalance(currentBalance?.value || 0, item)
              : '-'}
          </div>
          <ButtonSecondary
            className={`${cn.activateButton} button-white`}
            text={currentBalance ? 'Disable' : 'Enable'}
            icon={
              currentBalance ? (
                <IconBlock className={cn.blockBalanceIcon} />
              ) : (
                <IconSelected className={cn.enableIcon} />
              )
            }
            size={ButtonSize.SMALL}
            onClick={() => {
              if (currentBalance) {
                setBlockPopupVisible(true);
                setSelectedBlockCurrency(item);
              } else {
                setEnablePopupVisible(true);
                setSelectedEnableCurrency(item);
              }
            }}
            disabled={Boolean(currentBalance && currentBalance?.value)}
          />
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatCurrencies;
